export function pluralize(singular, count, plural) {
  if(count > 1) { 
    return plural ? plural : `${singular}s`
  } else {
    return singular
  }
}